import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Heading from "src/components/Heading";
import Page from "src/components/Page";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import UserTermsPrivacyCs from "src/content/UserTermsPrivacyCs";
import UserTermsPrivacyEn from "src/content/UserTermsPrivacyEn";
import UserTermsPrivacySk from "src/content/UserTermsPrivacySk";
import getDefaultOg from "src/functions/getDefaultOg";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sPageTermsPrivacy } from "src/styles/sPageTermsPrivacy.module.scss";
import { sParagraph } from "src/styles/sParagraph.module.scss";

export default function Terms_and_privacy() {
  const { locale: lang } = useRouter();

  return (
    <>
      <Headers data={getDefaultOg(lang)} />

      <Page
        className={composeClassNames([
          sPageTermsPrivacy,
          "page-terms-andprivacy",
        ])}
      >
        <Header />
        <Content fluid={`xl`}>
          <Heading type={`h1`} title={<Translate tKey={`Terms & Privacy`} />} />
          <Heading
            type={`h2`}
            title={
              <>
                <Translate tKey={`GENERAL TERMS AND CONDITIONS`} />
                <br />
                <Translate
                  tKey={`for the use of digital content through the anandita.cz portal`}
                />
              </>
            }
            className={composeClassNames([sAlign, "center"])}
          />
          {(function () {
            switch (lang) {
              case `cs`:
                return <UserTermsPrivacyCs />;
              case `sk`:
                return <UserTermsPrivacySk />;
              case `en`:
                return <UserTermsPrivacyEn />;
            }
          })()}
          <Paragraph className={composeClassNames([sParagraph, "xn"])}>
            <Translate tKey={`In Opava 1. 5. 2021, Pavol Hudran`} />
          </Paragraph>
        </Content>
        <Footer />
      </Page>
    </>
  );
}
